import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react"
import { buttonClasses, ButtonSize, ButtonVariant } from "components/ui/buttonStyles"
import { Spinner } from "components/ui/Spinner"

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  /** Stretch to the full width of the container and center its contents. */
  fullWidth?: boolean
  /** Show a loading state; disables the button and renders a spinner. */
  isLoading?: boolean
  children: ReactNode
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = "primary",
    size = "md",
    fullWidth = false,
    isLoading = false,
    disabled,
    className,
    children,
    type = "button",
    ...props
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || isLoading}
      className={buttonClasses({ variant, size, fullWidth, className })}
      {...props}
    >
      {isLoading && <Spinner className="-ml-0.5 mr-2 h-4 w-4" />}
      {children}
    </button>
  )
})
